import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GraphQLTable from '../../../../../components/_table/GraphQLTable';
import {
  IDropshippingRequestCompanyQueryData,
  IDropshippingRequestCompanyVars,
  useDropshippingRequestCompanyQuery,
} from '../../../../../../graphql/query/dropshippingRequestCompany/useDropshippingRequestCompanyQuery';
import { IDropshippingRequestCompanySchema } from '../../../../../../graphql/type/dropshippingRequestCompany';
import Helmet from '../../../../../components/Helmet';
import Context from '../../../../../context';
import DropshipperDropshippingVendorTableItem from './DropshipperDropshippingVendorTableItem';
import SelectDropshippingRequestCompanyRelatedCompany from './_module/SelectDropshippingRequestCompanyRelatedCompany';
import ProductLayout from '../../../../../layout/Product';

function DropshipperDropshippingVendorTable() {
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<
    IDropshippingRequestCompanySchema[]
  >([]);

  return (
    <>
      <Helmet title={`${t('dropshipping_vendor_list')} | ${t('product')}`} />
      <GraphQLTable<
        IDropshippingRequestCompanyQueryData,
        IDropshippingRequestCompanySchema,
        IDropshippingRequestCompanyVars
      >
        refreshKey={tableRefreshKey}
        select={`
				_id
				to_company_id
				toCompanyData {
				    _id
					origin
					verification
					slug
					name {
                        la
                        text
                    }
				}
				status 
				created {
					time 
				}
       	 `}
        useQuery={useDropshippingRequestCompanyQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'name',
            label: t('company'),
            align: 'center',
          },
          {
            field: 'origin',
            label: t('origin'),
            align: 'center',
          },
          {
            field: 'status',
            label: t('status'),
            align: 'center',
          },
          {
            field: 'createdTime',
            label: t('created'),
            align: 'center',
            sortable: true,
          },
        ]}
        renderItem={(item) => (
          <DropshipperDropshippingVendorTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        filterFields={{
          _id: {
            label: t('company'),
            component: SelectDropshippingRequestCompanyRelatedCompany,
            componentProps: {
              filter: {
                fromCompanyId: company._id,
              },
              menuPosition: 'fixed',
            },
            onChange: (option) => (option ? option.value : null),
            size: 12,
          },
        }}
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        defaultFilterOptions={{
          fromCompanyId: company._id,
        }}
        searchFields={{
          _id: { label: t('id') },
        }}
        title={t('dropshipping_vendor_list')}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        itemKey="_id"
      />
    </>
  );
}

export default () => (
  <ProductLayout main={<DropshipperDropshippingVendorTable />} />
);
